export default "__VITE_ASSET__sbl$GUXL__"